export const getErrorMessage = (error: any): string => {
  console.log("first error", error);

  // Handle different error structures
  // Direct axios error
  if (error?.response?.data?.Message) {
    return error.response.data.Message;
  }

  // Lowercase message
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  // Redux thunk error with payload
  if (error?.response?.data?.Message) {
    return error.response.data.Message;
  }

  // Direct message on error object
  if (error?.Message) {
    return error.Message;
  }

  if (error?.message) {
    return error.message;
  }

  // Fallback
  return "An unknown error occurred";
};

export const getSuccessMessage = (response: any): string => {
  return response?.data?.Message || response?.data?.message || "Successfull";
};
